import { Container, Button,Form, Alert, Modal, Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,StyckeCompact} from "../ContentStyles";
import React, { useState ,useEffect} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend';
import {Branding, DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, AddTimezoneOffset} from '../../services/misc';

var typingTimeout = null;
var shopGUID = null;

export default function ShopEdit() {
    const {ShopGUID} = useParams();
    shopGUID = ShopGUID;

    const {loading, data, Refresh} =  useBackend('/api/admin/shop/'+ShopGUID);

	const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);

	const [modalshowAddDevice,  setModalshowAddDevice] = useState(false);
	const initModalAddDevice = () => { return setModalshowAddDevice(!modalshowAddDevice) } 

	function handleChange(event){
		clearTimeout(typingTimeout);
		typingTimeout = setTimeout(handleSave, 475);
	}

	async function RenewEntryCodeClicked(event){	
		event.preventDefault();
		await CallAPI('/api/admin/shop/'+shopGUID+'/renewentrycode',"PUT");	
		Refresh();
	}

	async function ReleaseLockAsync(event){	
		event.preventDefault();
		const confirmDelete = window.confirm("Är du säker på att du vill radera?");
		if (confirmDelete) {
			const doorguid = event.currentTarget.getAttribute("doorguid");
			await CallAPI('/api/admin/shop/'+shopGUID+'/ReleaseLock/'+doorguid,"PUT");	
			Refresh();
		}
	}

	async function handleSave(){
		const ProductForm = document.getElementById('ProductForm');
		const formData = new FormData(ProductForm);
	
		const formDataObj = Object.fromEntries(formData.entries());
	
		formDataObj.Swish       = formData.has('Swish') ? true : false;
		formDataObj.Enabled       = formData.has('Enabled') ? true : false;
		formDataObj.Enabled       = formData.has('Enabled') ? true : false;
		
		formDataObj.CustomizedPayment        = formData.has('CustomizedPayment') ? true : false;
		formDataObj.TestPayment = formData.has('TestPayment') ? true : false;

		formDataObj.OpeningHoursUTCStart = ConcatLocalDateAndTime2ISO("1900-01-01",formDataObj.OpeningHoursUTCStart);
		formDataObj.OpeningHoursUTCEnd   = ConcatLocalDateAndTime2ISO("1900-01-01",formDataObj.OpeningHoursUTCEnd);

		await CallAPI('/api/admin/shop/'+shopGUID,"PATCH",JSON.stringify(formDataObj));
		Refresh();		
	}

	const handleClaimSubmit = async (e) =>{
		e.preventDefault();
		setResultText("");
		setResultVisible(false);
		const AddDeviceForm = document.getElementById('AddDeviceForm');
		const formData = new FormData(AddDeviceForm);
		const formDataObj = Object.fromEntries(formData.entries());
		formDataObj.Description = ".";

		let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/shop/'+shopGUID+'/ClaimLock', 'PUT', JSON.stringify(formDataObj));

		setResultVariant(resultVariant);   
		setResultText(resultText);
		setResultVisible(resultVisible);

		setResultVisible(true);

		Refresh();
		//RefreshLockState();
	}  

	function createDocument(event){
		const docType = event.currentTarget.getAttribute("docType");
		window.open('https://www.nookshop.se/api/shop/'+shopGUID+'/docs/'+docType, '_blank', 'noreferrer');
	}  

    if (!loading) {
        return (
            <ContentWrapper>

				<Modal show={modalshowAddDevice} onHide={initModalAddDevice}>
					<Modal.Header closeButton>
						<Modal.Title>Lägg till dörr/kylskåp/låsenhet</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form onSubmit={handleClaimSubmit} id="AddDeviceForm">

							<Form.Group className="mb-3" >
									<Form.Label>Namn på dörren</Form.Label>
									<Form.Control type="text" name ="Name" placeholder="Ange namn på dörren/kylskåpet/låset" />
							</Form.Group>

							<Form.Group className="mb-3" >
									<Form.Label>ID på låsmodul/kylskåp</Form.Label>
									<Form.Control type="text" name ="DeviceId" placeholder="" />       
							</Form.Group>

							<Form.Group className="mb-3"  hidden={!loading}>
								<SpinnerX  />
							</Form.Group>                                      
								
							<Form.Group className="mb-3"  hidden={!resultVisible}>
								<Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
							</Form.Group>                        

							<Form.Group className="mb-3">
															  
							</Form.Group>                                        
						</Form>                      
					</Modal.Body>
					
					<Modal.Footer>

					{/* <Button className="QmeButton_" variant="secondary" type="submit" onClick={initModalAddDevice}>Avbryt</Button>   */}
					<Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="warning" type="submit" onClick={handleClaimSubmit}>Lägg till Enheten</Button>  
					</Modal.Footer>
				</Modal>				
				
                <Container>
                    <Sida>
						<Rubrik>Butiksinformation</Rubrik>

						<Form onSubmit={handleSave} id="ProductForm">

							<Form.Group className="mb-3" >
                                <Form.Label>Namn</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="Name" placeholder="ButikID"  defaultValue={data.Shop.Name} />
							</Form.Group>

							<Form.Group className="mb-3" >
                                <Form.Label>Beskrivning</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="Description" placeholder="Produktbeskrivning" defaultValue={data.Shop.Description} />
							</Form.Group>  

							<Form.Group className="mb-3" >
                                <Form.Label>Max tillåtna ofullständiga köp</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="MaxAllowedUncompletedSessions" placeholder="MaxAllowedUncompletedSessions" defaultValue={data.Shop.MaxAllowedUncompletedSessions} />
							</Form.Group>  

							<Form.Group className="mb-3" >
                                <Form.Label>Minsta ålder för att använda butiken</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="MinCustomerAge" placeholder="MinCustomerAge" defaultValue={data.Shop.MinCustomerAge} />
							</Form.Group>

							<Form.Group className="mb-3" >
                                <Form.Label>Öppettider</Form.Label>
								<div className="d-flex">
									<Form.Control type="time"  onChange={handleChange} name="OpeningHoursUTCStart" defaultValue={SplitoutLocalTimeFromISO(data.Shop.OpeningHoursUTCStart)} size='sm' step="60"/>&nbsp;till&nbsp;
									<Form.Control type="time"  onChange={handleChange} name="OpeningHoursUTCEnd"   defaultValue={SplitoutLocalTimeFromISO(data.Shop.OpeningHoursUTCEnd)}   size='sm' step="60"/>
								</div>
							</Form.Group>
													
							<Form.Group className="mb-3">
								<Form.Label>EntryCode</Form.Label>
								<div className="d-flex">
								{data.Shop.EntryCode!=null ?
									(<Form.Control type="text"  value={data.Shop.EntryCode} disabled />) :(<Form.Control type="text"  disabled />)
								}&nbsp;
								{/* <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit" onClick={RenewEntryCodeClicked}>Förnya</Button> */}
								</div>
							</Form.Group>

							<Form.Group className="mb-3" >
								<Form.Check 
									type="switch"
									name="Enabled"
									id="Enabled"
									label={'Aktivera Butik'}									
									defaultChecked={data.Shop.Enabled}
									value={data.Shop.Enabled}
									onChange={handleChange}
								/>
							</Form.Group>

							<Rubrik>Betalalternativ</Rubrik>

							<Form.Group className="mb-3" >
								<Form.Check 
									type="switch"
									name="Swish"
									id="Swish"
									label={'Swish (' + data.Instance.SwishIdentifier +')'}
									disabled={!data.Instance.ConfiguredPayments.Swish}
									defaultChecked={data.Shop.Swish}
									value={data.Shop.Swish}
									onChange={handleChange}
								/>
							</Form.Group>

{/* 							<Form.Group className="mb-3" >
								<Form.Check 
									type="switch"
									name="TestPayment"
									id="TestPayment"
									label="Testbetalning"
									disabled={!data.Instance.ConfiguredPayments.TestPayment}
									defaultChecked={data.Shop.TestPayment}
									onChange={handleChange}
								/>
							</Form.Group>	 */}																			                          
							
							<Form.Group className="mb-3" >
								<Form.Check 
									type="switch"
									name="CustomizedPayment"
									id="CustomizedPayment"
									label={'Kundanpassad betalningslösning (' + data.Instance.ConfiguredPayments.CustomizedPaymentName + ')'}
									disabled={!data.Instance.ConfiguredPayments.CustomizedPayment}
									defaultChecked={data.Shop.CustomizedPayment}
									onChange={handleChange}
								/>
							</Form.Group>          

							{/* {!data.Instance.ConfiguredPayments.Swish &&  */}
								<Form.Group className="mb-3" >
									<Alert variant="danger">Innan Swish kan aktiveras behöver ett certifikat för Swish-handel installeras. Har du redan ett Swish-handel avtal med din bank, kan du utfärda ett certifikat på https://portal.swish.nu i annat fall kontakta din Bank för mer info.<br/>Du kommer behöva en CSR-fil, den får du av oss.</Alert>
								</Form.Group>
							{/* } */}
						</Form> 		

						<Rubrik>Skyltar och dokument för den här butiken</Rubrik>
						<StyckeCompact>
							<Button className="QmeButtonSmall" variant="primary" type="button" onClick={createDocument} docType="display">Skylt till kylskåp 480x230mm</Button>
							<Button className="QmeButtonSmall" variant="primary" type="button" onClick={createDocument} docType="sticker">Klistermärke till dörr 140x142mm</Button>
							<Button className="QmeButtonSmall" variant="primary" type="button" onClick={createDocument} docType="pricelist">Prislista</Button>
						</StyckeCompact>

						<Rubrik>Kopplade lås</Rubrik>
						<StyckeCompact>
							<div style={{display:'flex'}}>
								{(!loading) &&
									data.Shop.Doors.map((door) => {
										return <>
											<div style={{float:'left', marginRight:'50px', marginBottom:'20px'}}>
												<table>
													<>
														<tr><td><b>Namn:</b></td><td>{door.Description}</td></tr>
														<tr><td>Låstyp:</td><td>{door.LockType}</td></tr>											
														<tr><td>Dörr:</td><td><font color={door.DoorClosed ? "#4da850" : "#ff0000"}><b>{door.DoorClosed ? "Stängd":"Öppen"}</b></font></td></tr>
														<tr><td>Uppkoppling:</td><td><font color={door.Online ? "#4da850" : "#ff0000"}><b>{door.Online ? "Online":"Offline"}</b></font></td></tr>
														<tr><td>Senaste kontakt:</td><td>{DateTimeToLocal(door.LastPing)}</td></tr>
														<tr><td>Signalstyrka (dBm):   </td><td>{door.RSSI}</td></tr>																					
													</>
												</table>
												<Button style={{backgroundColor:Branding().ButtonColor}} className="QmeButton" doorguid={door.Guid} onClick={ReleaseLockAsync}>Koppla från Lås</Button>
											</div>								
										</>
									})							
								}
								
								<div style={{float:'left',  marginRight:'50px', marginBottom:'20px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>							
									<Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} onClick={initModalAddDevice}>Anslut nytt lås</Button>
								</div>
							</div>
						</StyckeCompact>								
						
						<Form.Group className="mb-3"  hidden={!loading}>
							<SpinnerX  />
						</Form.Group>                                      
							
						<Form.Group className="mb-3"  hidden={!resultVisible}>
							<Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert> 
						</Form.Group> 																

                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}